<template>
    <div class="max-width-content">

        <h1 class="text-5xl text-teal-800">Keywords</h1>

        <breadcrumbs>
            Keywords
        </breadcrumbs>

        <p class="mt-5">
            Dit zijn de keywords die gebruikt worden om een voorselectie te maken van de vacatures.
        </p>
        <p class="mt-3">
            Een keyword in de vacaturetitel is 3 "punten", een keyword in de omschrijving 1 punt. <br />
            Bij <strong>{{ score }} punten</strong> wordt een vacature geselecteerd en klaar gezet voor review</p>


        <div class="mt-5 bg-white rounded-lg px-8 py-5">

            <form @submit.prevent="submit" ref="form">


                <textarea-input v-model="form.keywords"
                    :errors="$page.props.errors.keywords"
                    class="mb-3 h-full"
                    rows="10"
                    label="Keywords"
                />
                <div><em>1 keyword (meerdere woorden toegestaan) per regel.</em></div>

                <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
                    <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
                </button>
            </form>


        </div>
    </div>
</template>

<script>
import Layout from "@/admin/Shared/Layout";
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Breadcrumbs from "@/admin/Shared/Breadcrumbs";
import TextareaInput from "@/admin/Shared/TextareaInput";

export default {
    metaInfo() {
        return { title: 'Keywords' };
    },

    layout: (h, page) => h(Layout, [page]),

    components: {
        Breadcrumbs, TextareaInput,
    },

    mixins: [Helpers],

    props: {
        keywords: String,
        score: Number
    },

    data() {
        return {
            form: {
                keywords: this.keywords,
            }
        };
    },

    methods: {
        submit(data) {
            this.loading = "submit";

            const url = this.route("admin.keywords.update").url();
            const options = { onFinish: () => this.loading = false};

            this.$inertia.patch(url, this.form, options)
        },

    }
};
</script>
